import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '../../contexts';

const useSectionStyles = () => {
    const theme = useWolfTheme();

    return useMemo(
        () => ({
            section: css({
                margin: `${theme.orbitalFour} 0`,
            }),
        }),
        [theme.orbitalFour]
    );
};

export default useSectionStyles;
